import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const ChooseAnotherAttribute = ({ goBack }) => {
	useTitle("Anderes Merkmal wählen");

	const buttons = [
		{
			label: "Zur Auswahl",
			variant: "primary",
			onClick: goBack,
			size: "small",
			tabIndex: 1,
			ariaLabel: "Zurück zur  Auswahl der Verifikationsoptionen"
		}
	];
	const icons = [
		{
			name: "warning-type-standard",
			size: 64,
			color: "var(--color-warning)"
		}
	];

	return (
		<Container
			title="Anderes Merkmal wählen"
			description="Die Daten wurden leider zu häufig fehlerhaft eingegeben. Aus Sicherheitsgründen ist dieses Merkmal deshalb für die Bestätigung Ihrer E-Mail-Adresse gesperrt. Bitte wählen Sie ein anderes Merkmal aus."
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default ChooseAnotherAttribute;
